module.exports = __webpack_public_path__ + "img/cuff_length.3af2655d.png";